module.exports = __webpack_public_path__ + "assets/img/87c5fe84b73b249703b8bd6abd24d5bb.png";